// import { SHOW_ADD_DEALER_MODAL, HIDE_ADD_DEALER_MODAL } from "./dealerModalDispatcher";

import { HIDE_ADD_DEALER_MODAL, SHOW_ADD_DEALER_MODAL } from "../../constants/actions";

const initialState = {
  isAddDealerModalOpen: false,
};

const dealerModalReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_ADD_DEALER_MODAL:
      return { ...state, isAddDealerModalOpen: true };

    case HIDE_ADD_DEALER_MODAL:
      return { ...state, isAddDealerModalOpen: false };

    default:
      return state;
  }
};

export default dealerModalReducer;
